


export const Contacts = () => {
    return <section className={'contacts'}>
        <div className="container">
            <div className="contacts_inner">
                <div className="title">
                    <h1>Контакты</h1>
                    <h2>Контакты</h2>
                </div>
                <div className="contacts_content">
                    <ul>
                        <li>
                            <h3>Я всегда на связи и стараюсь моментально отвечать на сообщения.</h3>
                        </li>
                        <li>
                            <img src="./assets/images/contacts/telegram.svg" alt=""/>
                            <a href="https://t.me/rockyatoyan" target='_blank'>Telegram</a>
                        </li>
                        <li>
                            <img src="./assets/images/contacts/vk.svg" alt=""/>
                            <a href="https://vk.com/vostavchiy" target='_blank'>VK</a>
                        </li>
                        <li>
                            <img src="./assets/images/contacts/mail.svg" alt=""/>
                            <h3>
                                <span>atoyanrobert21@gmail.com</span>
                            </h3>
                        </li>
                        <li>
                            <img src="./assets/images/contacts/whatsapp.svg" alt=""/>
                            <a href="tel:+79517893502" >Whatsapp</a>
                        </li>
                        <li>
                            <img src="./assets/images/contacts/discord.svg" alt=""/>
                            <h3>
                                <span>ArmenianGod#9034</span>
                            </h3>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
}